// (function ($) {
//     'use strict';

//     function init () {
//       if (!document.querySelector('.tribe-events')) {
//         setTimeout(init, 50);
//         return;
//       }

//       function sendHeightToParent () {
//         var height = document.body.scrollHeight;
//         parent.postMessage(
//           { type: 'iframeHeight', height: height },
//           window.location.origin
//         );
//       }

//       sendHeightToParent();

//       window.addEventListener('load', sendHeightToParent);

//       var observer = new MutationObserver(function () {
//         sendHeightToParent();
//       });
//       observer.observe(document.body, {
//         childList: true,
//         subtree:   true,
//         attributes:true
//       });
//     }

//     $(document).ready(init);

//   })(jQuery);
